import { Resource } from "src/app/core/jsonapi/resource";
import { Capability } from "../../common/_types/capability";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";

export class WorkerGuardShift extends Resource {
    public override type = 'workerGuardShifts';

    @prop()
    @required()
    public workerId!: string;

    @prop()
    @required()
    public guardShiftId!: string;
    
}